"use client";

import { ArrowRight, Star } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const googleReviewsUrl = "https://www.google.com/maps/place/Pure+Moto+Performance/@45.6572106,25.6434986,828m/data=!3m1!1e3!4m8!3m7!1s0x40b35d242725e959:0xd8259985ad99edf!8m2!3d45.6572069!4d25.6460735!9m1!1b1!16s%2Fg%2F11pz8t8shm?entry=ttu&g_ep=EgoyMDI2MDUwMi4wIKXMDSoASAFQAw%3D%3D";
export default function DepoimentosDeClientes() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="224966" id="opinia-clienților" className="dark bg-black text-foreground pt-16 pb-24 lg:pt-24 lg:pb-32 border-t border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div ref={ref} className={`max-w-2xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-2xl font-default font-bold tracking-tighter uppercase text-white ![margin:0px_30px_24px_0px] md:text-5xl lg:text-6xl">
            Opinia Clienților
          </h2>
          <div className="mb-6 flex items-center gap-2 text-amber-400" aria-label="Evaluare 5 din 5 stele">
            {Array.from({
            length: 5
          }).map((_, index) => <Star key={index} className="h-6 w-6 fill-current" />)}
          </div>
          <div className="space-y-5 text-lg md:text-xl text-muted-foreground font-sans max-w-xl leading-relaxed">
            <p>
              Punem accent pe comunicare clară, atenție la detalii și servicii
              realizate cu seriozitate. Fiecare motocicletă este tratată
              responsabil, cu soluții adaptate nevoilor clientului.
            </p>
            <p>
              Pentru opinii reale de la clienți, poți consulta recenziile
              noastre pe Google.
            </p>
          </div>
        </div>

        <div className={`mt-12 flex justify-center transition-all duration-1000 delay-200 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Link to={googleReviewsUrl} newTab>
            <Button className="bg-primary hover:bg-primary/90 text-primary-foreground rounded-md px-8 py-6 font-default uppercase text-base tracking-widest h-auto font-black shadow-xl transition-transform hover:scale-105">
              Vezi pe Google
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}